import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import "./index.css";
import { router } from "./routes/router";
import { AppBootProvider } from "~/features/auth/components";
import i18n from "~/i18n";
import { queryClient } from "~/store/query-client";

await i18n.init();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppBootProvider>
        <RouterProvider router={router} />
      </AppBootProvider>
    </QueryClientProvider>
  </StrictMode>,
);
